import { withTheme } from 'styled-components';
import RingLoader from 'react-spinners/RingLoader';

export default withTheme(function Loader({ theme, ...props }) {
  return <RingLoader color={theme.colors.primary} {...props} />;
});
